import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { store } from '@sdb-develop/learning-composition-player/src/store/store.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { Router } from '@lit-labs/router';
import moment from 'moment/dist/moment.js';
import { getLanguage } from '@sdb-develop/learning-composition-player/src/helpers/translate.js';
import './sdb-route.js';
import '@sdb-develop/learning-composition-player/src/components/shared/sdb-spinner.js';
import '@sdb-develop/learning-composition-player/src/components/elearning/sdb-elearning-close-dialog.js';
import './app/polyfill.js';
if (!globalThis.URLPattern) {
    await import("urlpattern-polyfill");
}
@customElement('sdb-main')
class SdbMain extends connect(store)(LitElement) {

    constructor() {
        super();

        this._routes = new Router(this, []);
    }

    static get styles() {
        return css`
            :host {
                font-family: 'Source Sans Pro', 'sans-serif';
            }
        `;
    }

    render() {
        return html`
            <div class="sdb-content">
                <store-provider .value=${store}>
                    <sdb-route></sdb-route>
                </store-provider>
            </div>
        `;
    }

    firstUpdated() {
        moment.locale(getLanguage());
    }
}
